// extracted by mini-css-extract-plugin
export default {"container":"licenses_container__2z2PV","wrapper":"licenses_wrapper__KOjwC","title":"licenses_title__4z9S8"};